import { useDraggable, useDroppable } from '@dnd-kit/core';
import { CatalogListDragItemData } from '../../../utils/catalogListDragAndDrop.types';

interface UseDraggableCatalogCardParams {
  id: string;
  isDraggingDisabled: boolean;
  data: CatalogListDragItemData;
}

export const useDraggableCatalogCard = ({
  id,
  isDraggingDisabled,
  data,
}: UseDraggableCatalogCardParams) => {
  const {
    attributes,
    listeners,
    setActivatorNodeRef,
    setNodeRef: setDraggableNodeRef,
  } = useDraggable({ id, disabled: isDraggingDisabled, data });

  const { setNodeRef: setDroppableNodeRef } = useDroppable({ id });

  const setCardRef = (node: HTMLElement | null) => {
    setDraggableNodeRef(node);
    setDroppableNodeRef(node);
    setActivatorNodeRef(node);
  };

  return { attributes, listeners, setCardRef };
};
